module.exports = __webpack_public_path__ + "img/billing.ccf2dd78.svg";